import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import DiscussionEntries from "./DiscussionEntries";
import axios, { discussionClient } from "../../AxiosClient";
import CreateContentFlow from "../content/CreateContentFlow";
import AddBoxIcon from "@material-ui/icons/AddBox";
import IconButton from "@material-ui/core/IconButton";
import { Trans } from "react-i18next";
import { withRouter } from "react-router";
import { mdiFileDocumentEditOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { Drawer } from "@material-ui/core";
import classNames from "classnames";
import CloseIcon from "@material-ui/icons/Close";

const drawerWidth = "100%";

const styles = (theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: "100%",
    overflow: "visisble",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: "relative",
    textOverflow: "ellipsis",
    height: "100%",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    textOverflow: "ellipsis",
    // width: theme.spacing(6) + 1,
    // "& #sidebarContent": {
    // },
    width: 0,
    position: "relative",
    height: "100%",
  },
});

export class FullscreenDiscussion extends Component {
  componentDidMount() {
    discussionClient
      .get(`/discussion/${this.props.discussionId}`)
      .then((res) => {
        this.setState({ discussion: res.data });
      });
  }
  constructor(props) {
    super(props);
    this.state = {
      discussion: null,
      openCreateContent:
        this.props.location.state && this.props.location.state.createContent
          ? true
          : false,
      template: {},
      sections: {},
      json:
        "{'useCapitals':true,'useNumbers':false,'useSpecialCharacters':false,'minimumCharacters':8}",
      contentSection: 0,
      activeStep: 0,
    };
  }
  updateDiscussion = (discussion) => {
    this.setState({ discussion });
  };
  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          height: "calc(100% - 64px)",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {this.state.discussion && (
            <DiscussionEntries
              discussionId={this.state.discussion.discussionId}
              discussion={this.state.discussion}
              expert
              updateDiscussion={this.updateDiscussion}
              openCreateContent={() =>
                this.setState({ openCreateContent: true })
              }
            />
          )}
        </div>
        <div
          style={{
            height: "100%",
            width: this.state.openCreateContent ? "100%" : 0,
            display: this.state.openCreateContent ? "block" : "none",
          }}
        >
          <Drawer
            open={this.state.openCreateContent}
            variant="persistent"
            className={classNames(classes.drawer, {
              [classes.drawerOpen]: this.state.openCreateContent,
              [classes.drawerClose]: !this.state.openCreateContent,
            })}
            classes={{
              paper: classNames({
                [classes.drawerOpen]: this.state.openCreateContent,
                [classes.drawerClose]: !this.state.openCreateContent,
              }),
            }}
            anchor="right"
          >
            <CreateContentFlow
              close={
                <IconButton
                  onClick={() => this.setState({ openCreateContent: false })}
                >
                  <CloseIcon />
                </IconButton>
              }
              fullHeight
              noFromFile
              noElevation
            />
          </Drawer>
        </div>
      </div>
    );
  }
  onEntryCreated = (entry) => {
    this.setState({
      entries: {
        ...this.state.entries,
        content: [...this.state.entries.content, entry],
      },
    });
  };
}

const mapStateToProps = (state) => ({
  message: state.websocket.message,
});

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(withStyles(styles)(withRouter(FullscreenDiscussion)))
);
